import {useQuery} from "react-query";
import {laravelAxios} from "../apiClients/laravelClient";

export const useAppSettings = ({page}, options) => {
    return useQuery(['app-setting', page], () => {
        return laravelAxios.get(`/app-setting?page=${page}`);
    }, {
        refetchOnWindowFocus: false,
        initialData: {}, select: (res) => {
            const response = {};
            for (const element in res.data) {
                response[element.split("_").pop()] = res.data[element]?.startsWith("[") ? JSON.parse(res.data[element]) : res.data[element];
            }
            return response;
        },
        ...options,
    });
};